var tabs = {
	selectors: { },

	init: function () {
		var self = this;

		jQuery( document ).on( "click", ".js-tabs .tabs__nav a, .js-tabs .tabs-wsw__nav div" , function( e ) {
			e.preventDefault();
			
			jQuery( this ).closest( '.js-tabs' ).find( '.active' ).removeClass( 'active' );

			var newActiveTab = jQuery( this ).data( 'href' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( this ).closest( '.js-tabs' ).find( '[data-name="'+ newActiveTab +'"]' ).addClass( 'active' );
        });


		jQuery( '.js-tabs-blocks .tabs-blocks__nav a' ).each(function(){
			var searchTabs = jQuery( this ).data( 'href' );
			jQuery( searchTabs ).hide();
		});
		jQuery( '.js-tabs-blocks .tabs-blocks__nav li:first-of-type a' ).each(function(){
			var searchTabs = jQuery( this ).data( 'href' );
			jQuery( searchTabs ).show();
		});

		jQuery( document ).on( "click", ".js-tabs-blocks .tabs-blocks__nav a" , function( e ) {
			e.preventDefault();
			
			jQuery( this ).closest( '.js-tabs-blocks' ).find( '.active' ).removeClass( 'active' );

			jQuery( this ).closest( '.js-tabs-blocks' ).find( ' .tabs-blocks__nav a' ).each(function(){
				var searchTabs = jQuery( this ).data( 'href' );
				jQuery( searchTabs ).hide();
			});

			var newActiveTab = jQuery( this ).data( 'href' );
			jQuery( this ).parent().addClass( 'active' );

			jQuery( newActiveTab ).show();
        });
	},
};

export { tabs };
